<div class="header-bar">
  <h1>Orders</h1>
</div>

<p-tabView (onChange)="onTabChange($event)" [activeIndex]="selectedTab" class="hideTabPanel">
  <p-tabPanel #tabGlobalFilter header="All Orders"></p-tabPanel>
  <p-tabPanel #tabWaiting header="Accepted"></p-tabPanel>
  <p-tabPanel #tabUnallocated header="Pending"></p-tabPanel>
  <p-tabPanel #tabLive header="Live Now"></p-tabPanel>
  <p-tabPanel #tabCompleted header="Completed"></p-tabPanel>
  <p-tabPanel #tabCancelled header="Cancelled"></p-tabPanel>
  <p-tabPanel #tabClosed header="Closed"></p-tabPanel>
</p-tabView>

<div class="content-container">
  <div>
    <div *ngIf="selectedTab == 0 || selectedTab == null">
      <customer-jobs-grid
        #jobgrid
        [inboxType]="inboxType_GlobalFilter"
        (onGridAction)="onGridAction($event)"
        (jobSelectionChanged)="jobSelectionChanged($event)"
      ></customer-jobs-grid>
    </div>

    <div *ngIf="selectedTab == 1">
      <customer-jobs-grid
        #jobgrid
        [inboxType]="inboxType_Waiting"
        (onGridAction)="onGridAction($event)"
        (jobSelectionChanged)="jobSelectionChanged($event)"
      ></customer-jobs-grid>
    </div>

    <div *ngIf="selectedTab == 2">
      <customer-jobs-grid
        #jobgrid
        [inboxType]="inboxType_Unallocated"
        (onGridAction)="onGridAction($event)"
        (jobSelectionChanged)="jobSelectionChanged($event)"
      ></customer-jobs-grid>
    </div>

    <div *ngIf="selectedTab == 3">
      <vme-jobs-tasks
        #jobtasks
        [inboxType]="liveTasks_InboxType_Customer"
        [customers]="[]"
        [suppliers]="[]"
        (selectedTaskChange)="onTaskChanged($event)"
      ></vme-jobs-tasks>
    </div>

    <div *ngIf="selectedTab == 4">
      <customer-jobs-grid
        #jobgrid
        [inboxType]="inboxType_Completed"
        (onGridAction)="onGridAction($event)"
        (jobSelectionChanged)="jobSelectionChanged($event)"
      ></customer-jobs-grid>
    </div>

    <div *ngIf="selectedTab == 5">
      <customer-jobs-grid
        #jobgrid
        [inboxType]="inboxType_Cancelled"
        (onGridAction)="onGridAction($event)"
        (jobSelectionChanged)="jobSelectionChanged($event)"
      ></customer-jobs-grid>
    </div>

    <div *ngIf="selectedTab == 6">
      <customer-jobs-grid
        #jobgrid
        [inboxType]="inboxType_Closed"
        (onGridAction)="onGridAction($event)"
        (jobSelectionChanged)="jobSelectionChanged($event)"
      ></customer-jobs-grid>
    </div>
  </div>

  <div class="ui-g" *ngIf="jobIsSelected && selecteditem != null">
    <div class="card job-details-container">
      <h2>Order Details {{ selecteditem.job.orderNumber }}</h2>
      <job-details [jobAndTask]="selecteditem"></job-details>
    </div>
  </div>
</div>

<ng-template #loading>Loading...</ng-template>
